export default __webpack_public_path__ + "static/media/sub-logo.bfaf144b.png";